import { connect } from 'react-redux'
import PendingTeacher from './pending-teacher'
import {
  getPendingTeacher,
  getSchoolTeamId
} from '../../../../../../stores/school-team/school-team.selectors'
import {
  approveTeacher,
  disapproveTeacher
} from '../../../../../../stores/school-team/school-team.actions'
import { withMe } from 'pobble-components/dist/pobble-user'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { id, me, meRequest }) => {
  const pendingTeacher = getPendingTeacher(state, id)
  const schoolId = getSchoolTeamId(state)
  return {
    id,
    schoolId,
    userId: !meRequest.pending && me.account && me.account.id,
    name: pendingTeacher.account.full_name,
    avatar: pendingTeacher.account.avatar,
    email:
      pendingTeacher.account.email_identity &&
      pendingTeacher.account.email_identity.email,
    schoolLeader: pendingTeacher.school_leader,
    isCurrentUser: id === (!meRequest.pending && me.account && me.account.id)
  }
}

const mapDispatchToProps = dispatch => ({
  onApprove: id => dispatch(approveTeacher(id)).catch(errorHandler),
  onDecline: id => dispatch(disapproveTeacher(id)).catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PendingTeacher)
)
